module.exports = __webpack_public_path__ + "img/06.d36ec992.jpg";